// Added JavaScript proceeding theme.js (that doesn't require any liquid or any vars from the .js.liquid theme file)
// Allows for easier editing/highlighting when can be pure JS

//  Class added to page when scrolled
//    - Used so that back to top button appears when scrolled
$(window).scroll(function() {
  var s = $(".bbs-page");
  var pos = s.position();

  if (s.length) {
    var windowpos = $(window).scrollTop();
    if (windowpos >= pos.top & windowpos <=0) {
      s.removeClass("bbs-page--scrolled");
    } else {
      s.addClass("bbs-page--scrolled");
    }
  }
});

//  Class added to page when reaching bottom of page
$(window).scroll(function() {
   $(".bbs-page").removeClass("bbs-page--bottom");
   if ($(window).scrollTop() + $(window).height() > ($(document).height() - 100) ) {
       // At bottom
       $(".bbs-page").addClass("bbs-page--bottom");
   }
});

$(function () {
  // Bind apply filter on radio button select
  $('input[type=checkbox]').on('change', function() {
    var selection = $(this);
    if (selection.hasClass('bbs-filter-group-list-item-input')) {
      console.log('dz');
      selection.closest("form").submit();
    } else {
      console.log('dznt');
    }
  });

  // Product slider settings
  $('.bbs-product-slider').on('init', function(event, slick) {
    const $dots = $('.slick-dots');
    $dots.append('<div class="active-indicator"></div>');
    updateActiveIndicatorPosition(slick.currentSlide);
    $('.current').text(slick.currentSlide + 1);
    $('.total').text(slick.slideCount);
  });

  $('.bbs-product-slider').on('init', function(event, slick){
    if (slick.slideCount <= 1) {
      $('.slick-dots').hide(); // Hides the dots
    }
  });

  $('.bbs-product-slider').slick({
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    dots: true,
    arrows: true,
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
    autoplay: false,
    adaptiveHeight: false,
    touchThreshold: 100,
    useCSS: false,
    useTransform: false
  });

  // When the counter is clicked, go to the next slide
  $('.slick-counter').on('click', function() {
    $('.bbs-product-slider').slick('slickNext');
  });

  // Update current slide number before the change
  $('.bbs-product-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $('.current').text(nextSlide + 1);
  });

  // Update active indicator position
  $(".bbs-product-slider").on('setPosition', function(event, slick) {
    updateActiveIndicatorPosition(slick.currentSlide);
  });

  $(".bbs-product-slider").on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    updateActiveIndicatorPosition(nextSlide);
    // Update settings based on the new active slide
  });

  // Function to update the active indicator position
  function updateActiveIndicatorPosition(slideIndex) {
    const $activeIndicator = $('.active-indicator');
    const $dots = $('.slick-dots li');
    const $targetDot = $dots.eq(slideIndex);
    const targetLeft = $targetDot.position().left;
    const targetWidth = $targetDot.outerWidth(true);

    $activeIndicator.css({
      width: targetWidth,
      left: targetLeft
    });
  }

  // Custom drag functionality for dots
  let isDragging = false;
  let startPos = 0;

  function handleCustomDragging(e) {
    if (!isDragging) return;

    let currentPos = e.pageX || e.originalEvent.touches[0].pageX;
    let delta = currentPos - startPos;

    if (delta > 50) {
      // Swiped right
      $(".bbs-product-slider").slick('slickPrev');
      isDragging = false;
    } else if (delta < -50) {
      // Swiped left
      $(".bbs-product-slider").slick('slickNext');
      isDragging = false;
    }
  }

  function startCustomDragging(e) {
    const $dots = $('.slick-dots');
    if ($dots.is(e.target) || $dots.has(e.target).length > 0) {
      isDragging = true;
      startPos = e.pageX || e.originalEvent.touches[0].pageX;
    }
  }

  function stopCustomDragging() {
    isDragging = false;
  }

  // Attach event handlers for custom dragging
  $('.slick-dots').on('mousedown touchstart', startCustomDragging);
  $(document).on('mousemove touchmove', handleCustomDragging);
  $(document).on('mouseup touchend', stopCustomDragging);
  
});

$(document).ready(function () {
  // Define the max color range
  const startColor = [252, 252, 252];
  const maxColor = [230, 230, 230];
  const colorRange = maxColor.map((max, index) => max - startColor[index]);

  // Function to update gradient based on scroll
  function updateGradient() {
    const scrollPosition = $(window).scrollTop();

    // Smooth transition using sine wave for infinite looping
    const loopFactor = 900; // Controls scroll-to-loop ratio
    const scrollPercent = (Math.sin((scrollPosition / loopFactor) * Math.PI * 2) + 1) / 2;

    // Calculate current colors based on the sine wave
    const currentColor1 = startColor.map((start, index) =>
      Math.round(start + colorRange[index] * scrollPercent)
    );

    const currentColor2 = startColor.map((start, index) =>
      Math.round(start + colorRange[index] * (1 - scrollPercent))
    );

    const currentColor3 = startColor.map((start, index) =>
      Math.round(start + colorRange[index] * scrollPercent)
    );
    

    // Convert to CSS rgb format
    const color1 = `rgb(${currentColor1.join(',')})`;
    const color2 = `rgb(${currentColor2.join(',')})`;
    const color3 = `rgb(${currentColor3.join(',')})`;

    // Apply the gradient to elements with the .gradient class
    $('.gradient').css('background', `linear-gradient(0.40turn, ${color1} 33.33%, ${color2} 66.66%), ${color3} 100%`);
  }

  // Attach the scroll event
  $(window).on('scroll', updateGradient);

  // Initial update in case the user lands somewhere in the middle of the page
  updateGradient();

  const $mobileBannerButton = $('.bbs-mobile-banner-button-container');
  const $productCartButton = $('.bbs-product-cart-button-container');

  if (!$mobileBannerButton.length || !$productCartButton.length) return; // Ensure elements exist

  const productCartButtonOffset = $productCartButton.offset().top;

  $(window).on('scroll', function () {
      const scrollPosition = $(window).scrollTop();

      if (scrollPosition > productCartButtonOffset) {
          $mobileBannerButton.addClass('bbs-mobile-banner-button-container--show');
      } else {
          $mobileBannerButton.removeClass('bbs-mobile-banner-button-container--show');
      }
  });
});

window.onscroll = function() {

  let prevScrollPos = window.pageYOffset;

  const currentScrollPos = window.pageYOffset;
  const maxScrollPos = document.documentElement.scrollHeight - window.innerHeight;
  const projectNav = document.querySelector('.bbs-header-container');

  if (
    (prevScrollPos > currentScrollPos || currentScrollPos <= 100) &&
    currentScrollPos < maxScrollPos
  ) {
    // Scrolling up, at the top, or within the specified range from the bottom, add 'move' class
    projectNav.classList.remove('bbs-header-container--background');
  } else {
    // Scrolling down or at the bottom, remove 'move' class
    projectNav.classList.add('bbs-header-container--background');
  }

  prevScrollPos = currentScrollPos;
};

// Autoplay videos with 'autoplay' class on desktop, allows placeholder to show on low power mode
document.addEventListener("DOMContentLoaded", function () {
    const videos = document.querySelectorAll("video.autoplay");
    videos.forEach(video => {
        video.play().catch(error => console.log("Autoplay failed:", error));
    });
});

$(document).ready(function () {

  // Main menu open
  $('body').on('click', '.bbs-menu-open', function(e) {
    e.preventDefault();
    $(".bbs-page").addClass("bbs-page--menu-open");
    $(".bbs-page").removeClass("bbs-page--secondary-menu-open");
  });

  // Close main menu outside of container
  $('body').on('click', function (e) {
    // Check if the click is outside the pop up container
    if (!$(e.target).closest('.bbs-menu-page-overlay, .bbs-menu-open').length) {
        $(".bbs-page").removeClass("bbs-page--menu-open");
    }
  });

  // Secondary menu toggle
  $('body').on('mouseenter', '.bbs-secondary-menu-open', function(e) {
    e.preventDefault();
    $(".bbs-menu-brand-buttons").addClass("bbs-menu-brand-buttons--open");
  });

  $('body').on('mouseenter', '.bbs-secondary-menu', function(e) {
    e.preventDefault();
    $(".bbs-menu-brand-buttons").removeClass("bbs-menu-brand-buttons--open");
  });

  // Close secondary menu outside of container
  $('body').on('click', function (e) {
    // Check if the click is outside the pop up container
    if (!$(e.target).closest('.bbs-menu-page-overlay, .bbs-secondary-menu-open').length) {
        $(".bbs-page").removeClass("bbs-page--secondary-menu-open");
    }
  });

  // Menu close
  $('body').on('click', '.bbs-menu-close', function(e) {
    e.preventDefault();
    $(".bbs-page").removeClass("bbs-page--menu-open");
    $(".bbs-page").removeClass("bbs-page--secondary-menu-open");
  });

  // Extra information toggle
  $('body').on('click', '.bbs-extra-information-toggle', function(e) {
    e.preventDefault();
    $(this).parents(".bbs-extra-information-section").toggleClass("bbs-extra-information-section--open");
  });

  // FAQ toggle
  $('body').on('click', '.bbs-extra-faq-toggle', function (e) {
    e.preventDefault();
    $('.bbs-membership-faq-entry').not($(this).parents('.bbs-membership-faq-entry')).removeClass('bbs-membership-faq-entry--open');
    $(this).parents('.bbs-membership-faq-entry').toggleClass('bbs-membership-faq-entry--open');
  });

  // Info pop up toggle
  $('body').on('click', '.bbs-info-toggle', function(e) {
    e.preventDefault();
    $(".bbs-page").toggleClass("bbs-page--info-open");
  });

  // Close info pop up outside of container
  $('body').on('click', function (e) {
    // Check if the click is outside the pop up container
    if (!$(e.target).closest('.bbs-info-pop-up-container, .bbs-info-toggle').length) {
        $(".bbs-page").removeClass("bbs-page--info-open");
    }
  });

  // Filter pop up toggle
  $('body').on('click', '.bbs-filter-pop-up-toggle', function(e) {
    e.preventDefault();
    $(".bbs-page").toggleClass("bbs-page--filter-open");
  });

  // Close filter pop up outside of container
  $('body').on('click', function (e) {
    // Check if the click is outside the pop up container
    if (!$(e.target).closest('.bbs-filter-pop-up-container, .bbs-filter-pop-up-toggle').length) {
      $(".bbs-page").removeClass("bbs-page--filter-open");
    }
  });

  // Search toggle
  $('body').on('click', '.bbs-search-toggle', function(e) {
    e.preventDefault();
    $(".bbs-page").toggleClass("bbs-page--search-open");
    var $input = $(".bbs-search-input");
    $input.focus();
    var value = $input.val();
    $input.val('').val(value); // Setting value again to focus at the end
  });

  // Close search pop up outside of container
  $('body').on('click', function (e) {
    // Check if the click is outside the pop up container
    if (!$(e.target).closest('.bbs-search-pop-up-container, .bbs-search-toggle').length) {
        $(".bbs-page").removeClass("bbs-page--search-open");
    }
  });
});

// Add this to your theme's JavaScript file or in a script tag
document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.bbs-membership-image-slider');
  
  sliders.forEach(slider => {
    const afterImage = slider.querySelector('.bbs-membership-image-after');
    const handle = slider.querySelector('.bbs-membership-slider-handle');
    const icon = slider.querySelector('.bbs-slider-drag-icon');
    const lineOne = slider.querySelector('.bbs-membership-slider-line--one');
    const lineTwo = slider.querySelector('.bbs-membership-slider-line--two');
    let isDragging = false;
    
    function updateSlider(percentage) {
      const clampedPercentage = Math.max(0, Math.min(100, percentage));
      afterImage.style.clipPath = `inset(0 ${100 - clampedPercentage}% 0 0)`;
      handle.style.left = `${clampedPercentage}%`;
      icon.style.left = `${clampedPercentage}%`;
      lineOne.style.left = `${clampedPercentage}%`;
      lineTwo.style.left = `${clampedPercentage}%`;
    }
    
    function getPercentage(clientX) {
      const rect = slider.getBoundingClientRect();
      const x = clientX - rect.left;
      return (x / rect.width) * 100;
    }
    
    // Mouse events
    slider.addEventListener('mousedown', (e) => {
      isDragging = true;
      updateSlider(getPercentage(e.clientX));
    });
    
    document.addEventListener('mousemove', (e) => {
      if (isDragging) {
        updateSlider(getPercentage(e.clientX));
      }
    });
    
    document.addEventListener('mouseup', () => {
      isDragging = false;
    });
    
    // Touch events
    slider.addEventListener('touchstart', (e) => {
      isDragging = true;
      updateSlider(getPercentage(e.touches[0].clientX));
    });
    
    document.addEventListener('touchmove', (e) => {
      if (isDragging) {
        e.preventDefault();
        updateSlider(getPercentage(e.touches[0].clientX));
      }
    });
    
    document.addEventListener('touchend', () => {
      isDragging = false;
    });
  });
});